module.exports = __webpack_public_path__ + "static/img/BG.4244a68b.png";